import { useState } from "react";
import { toast } from "sonner";
import { Ban } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ReasonDialog } from "@/components/ReasonDialog";
import { api, errMsg } from "@/lib/api";

export const CancelContractButton = ({ c, reload }) => {
  const [open, setOpen] = useState(false);
  if (c.status === "annullato") return null;
  const confirm = async (reason) => {
    try {
      await api.post(`/contracts/${c.id}/cancel`, { reason });
      toast.success("Contratto annullato: resta in archivio e la data torna libera");
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <>
      <Button variant="outline" className="rounded-full text-[#991B1B] border-[#FECACA] hover:bg-[#FEF2F2]" onClick={() => setOpen(true)} data-testid="header-cancel-contract"><Ban size={15} className="mr-2" /> Annulla</Button>
      <ReasonDialog open={open} onOpenChange={setOpen} testId="header-cancel" title="Il cliente ci ha ripensato?" confirmLabel="Annulla contratto"
        description={`Il contratto${c.status === "firmato" ? " firmato" : ""} resterà in archivio con stato «Annullato», con firme, allegati, pagamenti e registro. La data torna libera in calendario, mentre i compleanni del cliente restano sempre in calendario.`}
        onConfirm={confirm} />
    </>
  );
};

export const CancelledBanner = ({ c }) => c.status === "annullato" ? (
  <div className="rounded-xl border border-[#FECACA] bg-[#FEF2F2] p-4 text-sm text-[#991B1B]" data-testid="cancelled-banner">
    <b>Contratto annullato</b> • Motivo: {c.cancel_reason || "—"}. Il documento resta consultabile in archivio; la data è di nuovo libera e i compleanni del cliente restano in calendario.
  </div>
) : null;
